<template>
  <div class="content content-fixed content-auth-alt">
    <div class="container ht-100p">
      <div
        class="ht-100p d-flex flex-column align-items-center justify-content-center"
      >
        <div class="wd-150 wd-sm-250 mg-b-30">
          <img src="/assets/img/img17.png" class="img-fluid" alt />
        </div>
        <h4 class="tx-20 tx-sm-24">Бүртгэл идэвхжүүлэх</h4>
        <p class="tx-color-03 mg-b-40">
          Таны бүртгүүлсэн и-мэйл хаягаар очсон бүртгэл баталгаажуулах кодыг
          доорх талбарт оруулаад баталгаажуулах дарна уу.
        </p>
        <!-- <p class="text-muted tx-color-03"></p> -->
        <div class="tx-13 tx-lg-14 mg-b-40">
          <div class="mg-b-10">
            <!-- @keypress="validateRegister($event)" -->
            <input
              v-model="code"
              maxlength="6"
              type="text"
              class="form-control"
              placeholder="Баталгаажуулах код оруулна уу"
            />
          </div>
          
          <button
            type="button"
            @click="renew()"
            class="mg-r-5 btn btn-white d-inline-flex  align-items-center"
          >
            Код ахин авах
          </button>
          <button
            type="button"
            @click="activate()"
            class="btn btn-success d-inline-flex text-white align-items-center"
          >
            Баталгаажуулах
          </button>
        </div>
        <span class="tx-12 tx-color-03"
          >жич: Баталгаажуулах и-мэйл таны INBOX folder-т очоогүй бол SPAM
          folder-оо шалгана уу.</span
        >
      </div>
    </div>
    <!-- container -->
  </div>
</template>

<script>
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";
import { localRead } from "@/libs/util";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      code: ""
    };
  },
  methods: {
    ...mapActions(["handleLoading"]),
    activate() {
      //console.log(this.$route.params);
      this.handleLoading({ isLoading: true });
      let uid=localRead("activationUserId");
      if(this.$route.params.u!=undefined)
        uid=this.$route.params.u;
      request({
        api: { method: "POST", url: "User/Activate" },
        data: {
          key: this.code,
          userId: uid,
          groupId: this.$store.state.app.activeGroup.id
        },
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          Notification.success({
            message:
              "Таны бүртгэл амжилттай идэвхжлээ. Та нэвтрэх нэр, нууц үгээ оруулна уу. Динамик платформд тавтай морилно уу",
            title: "Амжилттай",
            duration: 30000,
            type: "success",
            position: "top-right",
            offset: 50
          });
          this.$router.push({ name: "login" });
        }
      });
    },
    renew() {
      this.handleLoading({ isLoading: true });
      let uid=localRead("activationUserId");
      if(this.$route.params.u!=undefined)
        uid=this.$route.params.u;
      request({
        api: { method: "POST", url: "User/getNewActivationKey" },
        data: {
          key: this.code,
          userId: uid,
          groupId: this.$store.state.app.activeGroup
        },
        store: this.$store
      }).then(res => {
        this.handleLoading({ isLoading: false });
        if (res != false) {
          Notification.success({
            message:
              "Таны и-мэйл хаяг руу шинэ баталгаажуулах код илгээлээ. И-мэйл хаягаа шалгана уу",
            title: "Амжилттай",
            duration: 60000,
            type: "success",
            position: "top-right",
            offset: 50
          });
        }
      });
    }
  }
};
</script>
